/**
 * A key identifies one intended business operation, from the first attempt until it succeeds -
 * not one form and not one request. Modals mint a key when they open, and any successful mutating
 * response rotates it, so a form that stays open cannot have its next genuine submission swallowed
 * as a duplicate. A double-click submits twice before either response lands, so both requests
 * carry the same key and the backend collapses them into one.
 */
let currentKey = null;

// crypto.randomUUID() is unavailable over plain http, which is how the app is reached on the LAN.
const mintKey = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const beginOperation = () => {
  currentKey = mintKey();
  return currentKey;
};

export const rotateOperationKey = () => {
  if (currentKey) {
    currentKey = mintKey();
  }
};

export const endOperation = () => {
  currentKey = null;
};

export const currentOperationKey = () => currentKey;
